import { AdvisorSkills } from '@interhyp/module-case-assignment';
import { BaseLayout, Footer } from '@interhyp/platform-layout';
import React from 'react';

function AdvisorSkillsModule() {
  return (
    <>
      <BaseLayout>
        <AdvisorSkills />
      </BaseLayout>
      <Footer />
    </>
  );
}

export { AdvisorSkillsModule };
